import httpClient from "../apiClient";
import { TGetJourneysList, TGetJourneyData } from "./index.types";

export class JourneysAPI {
  static getJourneysList: TGetJourneysList = (data) => httpClient.post("journeys", data);
  static getJourneyData: TGetJourneyData = (id) => httpClient.post(`journeys/${id}`);
}
